import { Host, h } from "@stencil/core";
/**
 * A component that shows a vertical list of items as they fit. When they don't all fit, it puts the ones that don't fit into a dropdown menu.
 * @slot() - The items to show in the menu.
 */
export class DnnVerticalOverflowMenu {
    constructor() {
        this.showDropdownButton = false;
        this.showDropdownMenu = false;
        this.previousMenuWidth = 0;
    }
    componentDidRender() {
        requestAnimationFrame(() => {
            this.moveItemsToDropDownIfNecessery();
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentRect.width < this.previousMenuWidth) {
                        this.moveItemsToDropDownIfNecessery();
                    }
                    if (this.previousMenuWidth > 0 && entry.contentRect.width > this.previousMenuWidth) {
                        this.moveItemsToMenuIfPossible();
                    }
                    this.previousMenuWidth = entry.contentRect.width;
                }
            });
            this.resizeObserver.observe(this.element);
        });
    }
    moveItemsToDropDownIfNecessery() {
        const menuItems = Array.from(this.menu.querySelector("slot").assignedElements());
        const availableWidth = this.menu.getBoundingClientRect().width;
        let neededWidth = parseFloat(getComputedStyle(this.element).fontSize) * 2;
        menuItems.forEach(item => neededWidth += this.getFullWidth(item));
        neededWidth += (menuItems.length - 1) * parseFloat(getComputedStyle(this.element).fontSize);
        if (neededWidth > availableWidth) {
            this.showDropdownButton = true;
            var lastItem = menuItems[menuItems.length - 1];
            if (this.dropdown == undefined) {
                return;
            }
            lastItem.slot = "dropdown";
            this.moveItemsToDropDownIfNecessery();
        }
    }
    moveItemsToMenuIfPossible() {
        if (this.dropdown == undefined || !this.dropdown.hasChildNodes()) {
            return;
        }
        const menuItems = Array.from(this.menu.querySelector("slot").assignedElements());
        const availableWidth = this.menu.getBoundingClientRect().width;
        let neededWidth = parseFloat(getComputedStyle(this.element).fontSize) * 2;
        neededWidth += (menuItems.length - 1) * parseFloat(getComputedStyle(this.element).fontSize);
        menuItems.forEach(item => neededWidth += this.getFullWidth(item));
        const firstItem = this.dropdown.querySelector("slot").assignedElements()[0];
        if (firstItem != undefined) {
            neededWidth += this.getFullWidth(firstItem);
        }
        if (neededWidth < availableWidth) {
            if (firstItem != undefined) {
                firstItem.slot = "";
            }
            if (firstItem == undefined) {
                this.dropdown.classList.remove("visible");
                this.showDropdownMenu = false;
                this.showDropdownButton = false;
            }
        }
    }
    getFullWidth(item) {
        var width = item.getBoundingClientRect().width;
        var styles = getComputedStyle(item);
        width += parseFloat(styles.marginLeft);
        width += parseFloat(styles.marginRight);
        width += parseFloat(styles.paddingLeft);
        width += parseFloat(styles.paddingRight);
        return width;
    }
    toggleOverflowMenu() {
        this.showDropdownMenu = !this.showDropdownMenu;
        if (this.showDropdownMenu) {
            this.dropdown.classList.add("visible");
            let contentHeight = 0;
            const items = Array.from(this.dropdown.querySelector("slot").assignedElements());
            items.forEach(item => contentHeight += item.getBoundingClientRect().height);
            const emHeight = parseFloat(getComputedStyle(this.dropdown).fontSize);
            const gapsHeight = emHeight * (this.dropdown.children.length - 1) / 2;
            contentHeight += gapsHeight;
            const marginHeight = emHeight * 2;
            contentHeight += marginHeight;
            this.dropdown.style.height = `${contentHeight}px`;
            const dismissMenu = (e) => {
                const buttonRect = this.button.getBoundingClientRect();
                if (e.clientX < buttonRect.left ||
                    e.clientX > buttonRect.right ||
                    e.clientY < buttonRect.top ||
                    e.clientY > buttonRect.bottom) {
                    this.toggleOverflowMenu();
                }
                document.removeEventListener("click", dismissMenu);
            };
            setTimeout(() => {
                document.addEventListener("click", dismissMenu, false);
            }, 100);
        }
        else {
            this.dropdown.classList.remove("visible");
            this.dropdown.style.height = "0px";
        }
    }
    render() {
        return (h(Host, { key: 'f5d038ff61404f3e15eef0deb44051d0967c7e88' }, h("div", { key: '2277fdfd939c4d06f8dc275b9dfb92a688dc4910', class: "menu-container" }, h("div", { key: '07686f1acc098a389e3a2766e6a0e01f7370b0e3', class: "menu", ref: el => this.menu = el }, h("slot", { key: 'f03bade0de2c0c35f4db272ab30a8afde7ac04de' })), this.showDropdownButton &&
            h("div", { key: '8baa54e82d810f6b10625129642cf7f30bc3ef1f', class: "overflow" }, h("button", { key: 'e4571ea364927f89f2efcd8b6184c07865a7f7e9', ref: el => this.button = el, class: "icon", onClick: () => this.toggleOverflowMenu() }, h("svg", { key: 'e4dc876383112fbaec7d1aff22082eddaa5c9a44', xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { key: '0d4455483051a0600e690ea893ecaaf61b523af9', d: "M0 0h24v24H0z", fill: "none" }), h("path", { key: '189db323452d7d49d37d2e6dbc0f42f256403d28', d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }))), h("div", { key: '04aff4de4c423a37abb464eabfd950d8e280cfcb', class: "dropdown", ref: el => this.dropdown = el }, h("slot", { key: '0fb6aad3f798f42403cd6ee0fa4f324190ec610e', name: "dropdown" }))))));
    }
    static get is() { return "dnn-vertical-overflow-menu"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-vertical-overflow-menu.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-vertical-overflow-menu.css"]
        };
    }
    static get states() {
        return {
            "showDropdownButton": {},
            "showDropdownMenu": {}
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=dnn-vertical-overflow-menu.js.map
